export function createTrainingInstructionTableFields (vm) {
  return [
    { key: 'id', prop: 'id', label: '培训ID', width: 90 },
    { key: 'cover', label: '封面', width: 96, slot: 'cover' },
    { key: 'title', prop: 'title', label: '标题', minWidth: 180, showOverflowTooltip: true },
    {
      key: 'instruction_type',
      label: '类型',
      width: 110,
      slot: 'tag',
      formatter: row => vm.formatType(row),
      tagClass: row => vm.getTypeTagClass(row.instruction_type),
    },
    {
      key: 'is_common',
      label: '是否通用',
      width: 100,
      slot: 'tag',
      formatter: row => vm.formatIsCommon(row),
      tagClass: row => vm.getIsCommonTagClass(row.is_common),
    },
    {
      key: 'training_knowledge_name',
      prop: 'training_knowledge_name',
      label: '所属知识库',
      minWidth: 160,
      slot: 'knowledge',
      showOverflowTooltip: true,
    },
    {
      key: 'customer_name',
      prop: 'customer_name',
      label: '所属客户',
      minWidth: 120,
      showOverflowTooltip: true,
    },
    {
      key: 'app_display',
      label: 'App展示',
      width: 90,
      visibleWhen: 'showWorkerColumns',
      formatter: row => vm.formatAppDisplay(row),
    },
    {
      key: 'priority',
      prop: 'priority',
      label: '优先级',
      width: 90,
      visibleWhen: 'showWorkerColumns',
      tooltip: '在 App 学习中心内的展示顺序，数字越小优先级越高',
    },
    {
      key: 'instruction_group_name',
      prop: 'instruction_group_name',
      label: '分组',
      minWidth: 120,
      showOverflowTooltip: true,
      visibleWhen: 'showWorkerColumns',
    },
    {
      key: 'instruction_status',
      label: '状态',
      width: 100,
      slot: 'tag',
      formatter: row => vm.formatStatus(row),
      tagClass: row => vm.getStatusTagClass(row.instruction_status),
    },
    {
      key: 'trained_count',
      label: '已培训次数',
      width: 120,
      slot: 'link',
      linkIcon: 'book-open',
      linkTo: row => vm.getRecordLink(row),
      linkText: row => row.trained_count || 0,
      linkMuted: row => !Number(row.trained_count),
    },
    {
      key: 'trained_examination_count',
      label: '关联答卷数',
      width: 120,
      slot: 'link',
      linkIcon: 'file-pen',
      linkTo: row => vm.getExamRecordLink(row),
      linkText: row => row.trained_examination_count || 0,
      linkMuted: row => !Number(row.trained_examination_count),
    },
    { key: 'created_at', prop: 'created_at', label: '创建时间', width: 170 },
    {
      key: 'creator',
      label: '创建人',
      minWidth: 140,
      showOverflowTooltip: true,
      formatter: row => (row.creator_id ? `${row.creator_username} / ${row.creator_id}` : ''),
    },
  ]
}



// WEBPACK FOOTER //
// ./src/views/training/training-instruction-table.fields.js